"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERegimeFiscal = void 0;
exports.ERegimeFiscal = {
    is: "is",
    ir: "ir",
    nonAssujetti: "nonAssujetti",
};
